/*
    BEEP BOP BOOP - I AM AN AUTO GENERATED FILE - DO NOT EDIT ME MANUALLY
*/


// Name: Resource Types 

export const RESOURCE_TYPE_UNKNOWN_RESOURCE_TYPE = 'unknown_resource_type';
export const RESOURCE_TYPE_USER_ACCOUNT = 'user_account';
export const RESOURCE_TYPE_USER_ACCOUNT_BALANCE = 'user_account_balance';
export const RESOURCE_TYPE_USER_ACCOUNT_BALANCE_SOURCE = 'user_account_balance_source';
export const RESOURCE_TYPE_USER_HISTORY_ENTRY = 'user_history_entry';
export const RESOURCE_TYPE_BALANCE_CHANGE_LOG = 'balance_change_log';
export const RESOURCE_TYPE_INTERNATIONAL_USER_BANK_ACCOUNT = 'international_user_bank_account';
export const RESOURCE_TYPE_US_DOMESTIC_USER_BANK_ACCOUNT = 'us_domestic_user_bank_account';
export const RESOURCE_TYPE_USER_BANK_ACCOUNT_DELTA = 'user_bank_account_delta';
export const RESOURCE_TYPE_USER_ACCOUNT_SETTINGS = 'user_account_settings';
export const RESOURCE_TYPE_USER_ACCOUNT_ADMIN_GHOST = 'user_account_admin_ghost';
export const RESOURCE_TYPE_USER_ACCOUNT_FINALIZATION = 'user_account_finalization';
export const RESOURCE_TYPE_THIRD_PARTY_USER_ACCOUNT_MAPPING = 'third_party_user_account_mapping';
export const RESOURCE_TYPE_PREVIOUS_EMAIL_ADDRESS = 'previous_email_address';
export const RESOURCE_TYPE_PENDING_EMAIL_CHANGE = 'pending_email_change';
export const RESOURCE_TYPE_ARCHIVED_PENDING_EMAIL_CHANGE = 'archived_pending_email_change';
export const RESOURCE_TYPE_PASSWORD = 'password';
export const RESOURCE_TYPE_EXPIRED_PASSWORD = 'expired_password';
export const RESOURCE_TYPE_PASSWORD_RESET = 'password_reset';
export const RESOURCE_TYPE_DEPOSIT = 'deposit';
export const RESOURCE_TYPE_DEPOSIT_INVITE = 'deposit_invite';
export const RESOURCE_TYPE_DEPOSIT_ADJUSTMENT = 'deposit_adjustment';
export const RESOURCE_TYPE_DEPOSIT_INTEREST = 'deposit_interest';
export const RESOURCE_TYPE_DEPOSIT_HISTORY_ENTRY = 'deposit_history_entry';
export const RESOURCE_TYPE_DEPOSIT_CLOSE_REQUEST = 'deposit_close_request';
export const RESOURCE_TYPE_DEPOSIT_USER_STATS = 'deposit_user_stats';
export const RESOURCE_TYPE_DEPOSIT_BANK_MAPPING = 'deposit_bank_mapping';
export const RESOURCE_TYPE_DEPOSITS_BULK_IMPORT = 'deposits_bulk_import';
export const RESOURCE_TYPE_DEPOSIT_INTEREST_LOG = 'deposit_interest_log';
export const RESOURCE_TYPE_ARCHIVED_DEPOSIT_CLOSE_REQUEST = 'archived_deposit_close_request';
export const RESOURCE_TYPE_DEPOSIT_WITHHELD_FUNDS = 'deposit_withheld_funds';
export const RESOURCE_TYPE_PMC_REPORT_TIMETABLE = 'pmc_report_timetable';
export const RESOURCE_TYPE_DEPOSIT_GROUP = 'deposit_group';
export const RESOURCE_TYPE_DEPOSIT_POST_CLOSE_ADJUSTMENT = 'deposit_post_close_adjustment';
export const RESOURCE_TYPE_DEPOSIT_USER_GROUP = 'deposit_user_group';
export const RESOURCE_TYPE_PROPERTY_GROUP = 'property_group';
export const RESOURCE_TYPE_PROPERTY_USER_GROUP = 'property_user_group';
export const RESOURCE_TYPE_DISPUTE = 'dispute';
export const RESOURCE_TYPE_DISPUTE_SPLIT = 'dispute_split';
export const RESOURCE_TYPE_DISPUTE_INTERVENTION_REQUEST = 'dispute_intervention_request';
export const RESOURCE_TYPE_PROPERTY = 'property';
export const RESOURCE_TYPE_PROPERTY_ADDRESS = 'property_address';
export const RESOURCE_TYPE_COMPLIANCE = 'compliance';
export const RESOURCE_TYPE_COMPLIANCE_RULE = 'compliance_rule';
export const RESOURCE_TYPE_COMPLIANCE_HISTORY = 'compliance_history';
export const RESOURCE_TYPE_EMAIL_TEMPLATE = 'email_template';
export const RESOURCE_TYPE_EMAIL_VERIFICATION = 'email_verification';
export const RESOURCE_TYPE_EMAIL_VERIFICATION_RECORD = 'email_verification_record';
export const RESOURCE_TYPE_EMAIL_EVENT = 'email_event';
export const RESOURCE_TYPE_SENT_EMAIL = 'sent_email';
export const RESOURCE_TYPE_MAILBOX = 'mailbox';
export const RESOURCE_TYPE_MAILBOX_META_DATA = 'mailbox_meta_data';
export const RESOURCE_TYPE_MAILBOX_MESSAGE = 'mailbox_message';
export const RESOURCE_TYPE_PERMISSION_ENTRY = 'permission_entry';
export const RESOURCE_TYPE_PERMISSION_LOG_ENTRY = 'permission_log_entry';
export const RESOURCE_TYPE_PERMISSIONS_ORGANIZATION_SETTINGS = 'permissions_organization_settings';
export const RESOURCE_TYPE_RESOURCE_PERMISSIONS = 'resource_permissions';
export const RESOURCE_TYPE_ORGANIZATION = 'organization';
export const RESOURCE_TYPE_ORGANIZATION_RESOURCE_PERMISSION_RULE = 'organization_resource_permission_rule';
export const RESOURCE_TYPE_INVOICE = 'invoice';
export const RESOURCE_TYPE_INVOICE_ITEM = 'invoice_item';
export const RESOURCE_TYPE_PAYMENT_REQUEST = 'payment_request';
export const RESOURCE_TYPE_STRIPE_PAYMENT_LOG = 'stripe_payment_log';
export const RESOURCE_TYPE_USER_WITHDRAW = 'user_withdraw';
export const RESOURCE_TYPE_PRIORITY_ACH_PAYMENT = 'priority_ach_payment';
export const RESOURCE_TYPE_PRIORITY_ACH_RECURRING_PAYMENT = 'priority_ach_recurring_payment';
export const RESOURCE_TYPE_LOAN_APPLICATION = 'loan_application';
export const RESOURCE_TYPE_LOAN_SYSTEM_INFO = 'loan_system_info';
export const RESOURCE_TYPE_LOAN = 'loan';
export const RESOURCE_TYPE_LOAN_HISTORY = 'loan_history';
export const RESOURCE_TYPE_LOAN_PAYMENT_LOG = 'loan_payment_log';
export const RESOURCE_TYPE_STRIPE_WEBHOOK_LOG = 'stripe_webhook_log';
export const RESOURCE_TYPE_USER_ACCOUNT_PAYMENT_PROVIDER_INFO = 'user_account_payment_provider_info';
export const RESOURCE_TYPE_SEZZLE_ORDER = 'sezzle_order';
export const RESOURCE_TYPE_SEZZLE_WEBHOOK_EVENT = 'sezzle_webhook_event';
export const RESOURCE_TYPE_BANK_ACCOUNT = 'bank_account';
export const RESOURCE_TYPE_BANK_ACCOUNT_HISTORICAL_INTEREST_RATE = 'bank_account_historical_interest_rate';
export const RESOURCE_TYPE_BANK_ACCOUNT_INTEREST = 'bank_account_interest';
export const RESOURCE_TYPE_BANK_ACCOUNT_BALANCE_RECORD = 'bank_account_balance_record';
export const RESOURCE_TYPE_BANK_TRANSFER = 'bank_transfer';
export const RESOURCE_TYPE_BULK_FUNDS_TRANSFER = 'bulk_funds_transfer';
export const RESOURCE_TYPE_FUNDS_LOCK = 'funds_lock';
export const RESOURCE_TYPE_FUNDS_LOCK_RELEASE_LOG = 'funds_lock_release_log';
export const RESOURCE_TYPE_RELEASED_FUNDS_LOCK = 'released_funds_lock';
export const RESOURCE_TYPE_BALANCE_SOURCE_TRANSFER = 'balance_source_transfer';
export const RESOURCE_TYPE_CREDIT_USER_ACCOUNT_LOG = 'credit_user_account_log';
export const RESOURCE_TYPE_EVENT = 'event';
export const RESOURCE_TYPE_EVENT_HOOK = 'event_hook';
export const RESOURCE_TYPE_NOTIFICATION = 'notification';
export const RESOURCE_TYPE_ACTION_ITEM = 'action_item';
export const RESOURCE_TYPE_UPDATE_LOG_ENTRY = 'update_log_entry';
export const RESOURCE_TYPE_STORAGE_FILE = 'storage_file';
export const RESOURCE_TYPE_ATTACHED_STORAGE_FILES = 'attached_storage_files';
export const RESOURCE_TYPE_PRE_UPLOADED_FILE = 'pre_uploaded_file';
export const RESOURCE_TYPE_SYSTEM_HISTORY_ENTRY = 'system_history_entry';
export const RESOURCE_TYPE_SNAPSHOT = 'snapshot';
export const RESOURCE_TYPE_IP_ADDRESS = 'ip_address';
export const RESOURCE_TYPE_KNOWN_IP_ADDRESS = 'known_ip_address';
export const RESOURCE_TYPE_USER_AGENT = 'user_agent';
export const RESOURCE_TYPE_KNOWN_USER_AGENT = 'known_user_agent';
export const RESOURCE_TYPE_BASIC_USER_ACCOUNT_INFO = 'basic_user_account_info';
export const RESOURCE_TYPE_SYSTEM_STATS = 'system_stats';
export const RESOURCE_TYPE_RESOURCE_NOTE = 'resource_note';
export const RESOURCE_TYPE_DEPOSIFY_TAG = 'deposify_tag';
export const RESOURCE_TYPE_PERMANENT_LINK = 'permanent_link';
export const RESOURCE_TYPE_ONLINE_USER = 'online_user';
export const RESOURCE_TYPE_FRONTEND_GENERAL_SETTINGS = 'frontend_general_settings';
export const RESOURCE_TYPE_YARDI_SCREENING_WORKS_PRO_XML = 'yardi_screening_works_pro_xml';
export const RESOURCE_TYPE_YARDI_VOYAGER_XML = 'yardi_voyager_xml';
export const RESOURCE_TYPE_YARDI_VOYAGER_TRANSACTION = 'yardi_voyager_transaction';
export const RESOURCE_TYPE_YARDI_VOYAGER_RESIDENT = 'yardi_voyager_resident';
export const RESOURCE_TYPE_YARDI_VOYAGER_RESIDENT_CUSTOM_COLUMN = 'yardi_voyager_resident_custom_column';
export const RESOURCE_TYPE_YARDI_VOYAGER_PROPERTY_UNIT = 'yardi_voyager_property_unit';
export const RESOURCE_TYPE_YARDI_VOYAGER_PROPERTY = 'yardi_voyager_property';
export const RESOURCE_TYPE_YARDI_VOYAGER_PMC_SERVICE_INTERFACE_VERSION = 'yardi_voyager_pmc_service_interface_version';
export const RESOURCE_TYPE_YARDI_VOYAGER_PMC = 'yardi_voyager_pmc';
export const RESOURCE_TYPE_YARDI_VOYAGER_PMC_CREDENTIALS = 'yardi_voyager_pmc_credentials';
export const RESOURCE_TYPE_YARDI_VOYAGER_PET = 'yardi_voyager_pet';
export const RESOURCE_TYPE_YARDI_VOYAGER_ILS_GUEST_CARD_EVENT = 'yardi_voyager_ils_guest_card_event';
export const RESOURCE_TYPE_YARDI_VOYAGER_CHARGE = 'yardi_voyager_charge';
export const RESOURCE_TYPE_YARDI_VOYAGER_CHARGE_CODE = 'yardi_voyager_charge_code';
export const RESOURCE_TYPE_YARDI_VOYAGER_DEPOSIT_CREATE_INTENT = 'yardi_voyager_deposit_create_intent';
export const RESOURCE_TYPE_YARDI_VOYAGER_DEPOSIT_CLOSE_INTENT = 'yardi_voyager_deposit_close_intent';
export const RESOURCE_TYPE_YARDI_VOYAGER_DEPOSIT_WITHHOLD_INTENT = 'yardi_voyager_deposit_withhold_intent';
export const RESOURCE_TYPE_YARDI_VOYAGER_EVENT = 'yardi_voyager_event';
export const RESOURCE_TYPE_YARDI_VOYAGER_FLEX_DEPOSIT_INTENT = 'yardi_voyager_flex_deposit_intent';
export const RESOURCE_TYPE_YARDI_VOYAGER_PHONE = 'yardi_voyager_phone';
export const RESOURCE_TYPE_YARDI_VOYAGER_OTHER_OCCUPANT = 'yardi_voyager_other_occupant';
export const RESOURCE_TYPE_YARDI_VOYAGER_PMC_CUSTOM_COLUMN_SETTINGS = 'yardi_voyager_pmc_custom_column_settings';
export const RESOURCE_TYPE_YARDI_VOYAGER_PMC_STATS = 'yardi_voyager_pmc_stats';
export const RESOURCE_TYPE_YARDI_VOYAGER_PMC_STATS_COLLECTOR = 'yardi_voyager_pmc_stats_collector';
export const RESOURCE_TYPE_YARDI_VOYAGER_ACTIVE_SCAN_LOG_ENTRY = 'yardi_voyager_active_scan_log_entry';
export const RESOURCE_TYPE_YARDI_VOYAGER_SYSTEM_SETTINGS = 'yardi_voyager_system_settings';
